import { Button } from '@ps-design-system/components/Button';
import {
  MarketingCard,
  MarketingCardContent,
  MarketingCardFooter,
  MarketingCardHeader,
  MarketingCardTitle
} from '@ps-design-system/components/cards/MarketingCard';
import ArrowRightIcon from '@ps-design-system/icons/ArrowStylizedFilled/ArrowStylizedFilled16';
import GiftIcon from '@ps-design-system/icons/Gift/Gift24';
import React from 'react';
import { FormattedMessage } from 'react-intl';

export const ReferralsCard = () => {
  const handleCtaClick = () => {
    analyticsIntegrations.trackReferralClick('booking page');
    window.location.href = '/referrals';
  };

  return (
    <MarketingCard className="tw-bg-gray-100 tw-border-0">
      <MarketingCardHeader>
        <GiftIcon />
        <MarketingCardTitle>
          <FormattedMessage
            id="referrals_card.give_50_get_50"
            defaultMessage="Give $50. Get $50"
          />
        </MarketingCardTitle>
      </MarketingCardHeader>

      <MarketingCardContent>
        <FormattedMessage
          id="referrals_card.share_your_referral_link"
          defaultMessage="Share your referral link to give a $50 discount to friends and followers. When they book their first space, you’ll earn a $50 credit."
        />
      </MarketingCardContent>

      <MarketingCardFooter>
        <Button
          variant="text-only"
          appearance="purple"
          suffix={<ArrowRightIcon />}
          onClick={handleCtaClick}
        >
          <FormattedMessage
            id="referrals_card.get_referral_link"
            defaultMessage="Get referral link"
          />
        </Button>
      </MarketingCardFooter>
    </MarketingCard>
  );
};
